import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl,createQuestionPath,createSelectionPath,createAnswerPath} from "../../../../../../apiUrl"

export const QuestionModifyComponent = ({original}) => {
    const [processedData, setProcessedData] = useState([]);

    const mappingData = (data) => {
        return data.map(item => {
            return {
                originalText: item.problem.trim(),
                translateText: "(번역된 내용)" + item.selection.trim(),
                // translateText: item.trim(),
                exampleText: "(정답예시)" + item.answer.trim(),
                // exampleText: + item.trim(),
                id: item.id,
                selection_id: item.selection_id,
                answer_id: item.answer_id,
            }
        });
    };

    useEffect(() => {
        const newData = mappingData(original);
        setProcessedData(newData);
    }, [original]);

    useEffect(() => {
    }, [processedData]);

    const handleSubmit = async () => {
        for (const item of processedData) {
            await axios.patch(`${restUrl}/${createQuestionPath}?id=eq.${item.id}`, {problem: item.originalText})
            await axios.patch(`${restUrl}/${createSelectionPath}?id=eq.${item.selection_id}`, {selection: item.translateText})
            await axios.patch(`${restUrl}/${createAnswerPath}?id=eq.${item.answer_id}`, {answer: item.exampleText})
        }
    }

    const onChange = (index, type, event) => {
        const {value} = event.target;
        setProcessedData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                [type]: value,
            };
            return newData;
        });
    };

    if (processedData.length === 0) {
        return null;
    }
    else return (<>
        <h1>original : {processedData.map(it=>it.originalText).join('\n')}</h1>
        <ul className={`flex  gap-3`}>
            {["원문", "번역된 내용", "에디터"].map((item, index) => (
                <li key={`neoncw${index}`} className={`w-full px-2 py-3 bg-slate-800 text-white `}>{item} </li>
            ))}
        </ul>
        <ul className={`w-full `}>
            {processedData.length>0 && processedData.map((item, index) => (
                <li key={`qncwoep${index}`}
                    className={`flex w-full gap-3 [&_*]:p-2 mb-1  [&_*]:w-full [&_*]:h-[10rem]  [&_*]:border-2`}>
                        <textarea
                            value={item.originalText}
                            onChange={(e) =>
                                onChange(index, 'originalText', e)}
                        >
                            {/*원문*/}
                        </textarea>
                    <textarea
                        value={item.translateText}
                        onChange={(e) =>
                            onChange(index, 'translateText', e)}
                    >
                            {/*번역된 내용*/}
                        </textarea>
                    <textarea
                        value={item.exampleText}
                        onChange={(e) =>
                            onChange(index, 'exampleText', e)}
                    >
                            {/*에디터*/}
                        </textarea>
                </li>
            ))}

        </ul>
        <button className={`p-3 bg-slate-900 text-white`} onClick={handleSubmit}>제출하기</button>
    </>);
}
